import { createContext } from "react"

export const AdminToolsModalContext = createContext<{
  toggleAdminToolsModal: () => void
}>({
  toggleAdminToolsModal: () => {}
})
